module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cp_stills_pet_500_aq_pera.bc389f11.png";